window.addEventListener('velouraReveal', () => {
  const lines = [
    document.getElementById('veloura-line-1'),
    document.getElementById('veloura-line-2')
  ];

  lines.forEach((line, lineIndex) => {
    if (!line) return;

    const text = line.innerText;
    line.innerHTML = '';

    [...text].forEach((letter, index) => {
      const span = document.createElement('span');

      span.innerHTML = letter === ' ' ? '&nbsp;' : letter;
      span.style.opacity = '0';
      span.style.display = 'inline-block';
      span.style.transform = 'translateY(30px)';
      span.style.transition = 'all 0.6s ease';

      line.appendChild(span);

      setTimeout(() => {
        span.style.opacity = '1';
        span.style.transform = 'translateY(0)';
      }, (lineIndex * 1000) + (index * 80));
    });
  });
});

window.addEventListener('load', () => {
  const intro = document.getElementById('veloura-intro');
  const logo = document.getElementById('veloura-logo');
  const heroContent = document.querySelector('.veloura-hero__content');

  if (!intro || !logo) return;

  setTimeout(() => {
    logo.style.opacity = '1';
    logo.style.transform = 'translateY(0)';
  }, 300);

  setTimeout(() => {
    intro.classList.add('hide');

    if (heroContent) {
      heroContent.classList.add('revealed');
    }

    window.dispatchEvent(
      new CustomEvent('velouraReveal')
    );
  }, 2500);
});
document.addEventListener("DOMContentLoaded", () => {

  const heading = document.querySelector(".veloura-how__heading");

  const observer = new IntersectionObserver((entries) => {

    entries.forEach((entry) => {

      if (entry.isIntersecting) {
        heading.classList.add("show");
      }

    });

  }, {
    threshold: 0.4
  });

  if (heading) {
    observer.observe(heading);
  }

});
